var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTetherGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9L5 4H15L18 9L10 17L2 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43214 3H15.7834C16.0542 3 16.3045 3.14035 16.4395 3.36805L19.7467 8.94279C19.9181 9.23189 19.8672 9.59679 19.6226 9.83121L10.5197 18.555C10.2248 18.8376 9.75048 18.8376 9.45561 18.555L0.365088 9.843C0.114779 9.60313 0.0679074 9.22757 0.251971 8.93668L3.78698 3.35016C3.92466 3.13259 4.16896 3 4.43214 3ZM14.3177 5.48893V7.05311H11.0842V8.13761C13.3552 8.2535 15.0591 8.7295 15.0717 9.30004L15.0717 10.4894C15.059 11.0599 13.3552 11.5359 11.0842 11.6518V14.3133H8.93714V11.6518C6.66614 11.5359 4.96229 11.0599 4.94964 10.4894L4.94973 9.30004C4.96236 8.7295 6.66614 8.2535 8.93714 8.13761V7.05311H5.70362V5.48893H14.3177ZM10.0107 10.8347C12.4342 10.8347 14.4599 10.4322 14.9557 9.89471C14.5353 9.43891 13.0147 9.0802 11.0842 8.98168V10.1171C10.7382 10.1348 10.3791 10.1441 10.0107 10.1441C9.64232 10.1441 9.28314 10.1348 8.93714 10.1171V8.98168C7.00668 9.0802 5.48609 9.43891 5.0657 9.89471C5.56145 10.4322 7.58712 10.8347 10.0107 10.8347Z",
    fill: "#009393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherGreen);
export default __webpack_public_path__ + "static/media/tether-green.69da10fa4208f7d41b6f56533f036a41.svg";
export { ForwardRef as ReactComponent };